import React from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import Step from "../components/Step";
import TranslatedFormGroup from "../components/FormGroup";
import RevealInput from "../components/RevealInput";
import params from "../utils/url_params";
import { INPUT_NAMES } from "../utils/config";
import { isValid } from "../utils/validation";

const NamePhoneCodeStep = ({
	t,
	changeHandler,
	submitHandler,
	inputs,
	errors,
	onPrevious,
	processing,
}) => (
	<form onSubmit={submitHandler} noValidate>
		<p className="h5 mb-3">{t("detailsTitle")}</p>
		<TranslatedFormGroup
			valid={isValid(errors[INPUT_NAMES.firstName])}
			feedback={errors[INPUT_NAMES.firstName]}
			label={t("labels.firstName")}
		>
			<input
				onChange={changeHandler}
				className="form-control"
				type="text"
				maxLength="90"
				name={INPUT_NAMES.firstName}
				value={inputs[INPUT_NAMES.firstName]}
				required
				autoFocus
			/>
		</TranslatedFormGroup>
		<TranslatedFormGroup
			valid={isValid(errors[INPUT_NAMES.lastName])}
			feedback={errors[INPUT_NAMES.lastName]}
			label={t("labels.lastName")}
		>
			<input
				onChange={changeHandler}
				className="form-control"
				type="text"
				maxLength="90"
				name={INPUT_NAMES.lastName}
				value={inputs[INPUT_NAMES.lastName]}
				required
				autoFocus
			/>
		</TranslatedFormGroup>
		<TranslatedFormGroup
			valid={isValid(errors[INPUT_NAMES.phoneNumber])}
			feedback={errors[INPUT_NAMES.phoneNumber]}
			label={t("labels.phone")}
		>
			<input
				onChange={changeHandler}
				className="form-control"
				type="tel"
				name={INPUT_NAMES.phoneNumber}
				value={inputs[INPUT_NAMES.phoneNumber]}
				maxLength="45"
				required
			/>
		</TranslatedFormGroup>
		<RevealInput
			active={inputs[INPUT_NAMES.referral].trim().length > 0}
			label={t("haveReferralCode")}
		>
			<TranslatedFormGroup label={t("labels.referralCode")}>
				<input
					onChange={changeHandler}
					className="form-control"
					type="text"
					name={INPUT_NAMES.referral}
					value={inputs[INPUT_NAMES.referral]}
					disabled={
						processing || params.referralcode?.trim()
					}
				/>
			</TranslatedFormGroup>
		</RevealInput>
		<button
			className="btn btn-primary btn-block btn-lg"
			type="submit"
			disabled={processing}
		>
			{t("labels.continue")}
		</button>
		<button
			onClick={onPrevious}
			className="btn btn-block btn-link"
			disabled={processing}
		>
			{t("labels.previous")}
		</button>
	</form>
);

NamePhoneCodeStep.propTypes = {
	t: PropTypes.func,
	errors: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
	onPrevious: PropTypes.func,
	processing: PropTypes.bool,
	changeHandler: PropTypes.func,
	submitHandler: PropTypes.func,
	inputs: PropTypes.object,
};

export default translate()(
	Step(NamePhoneCodeStep, {
		[INPUT_NAMES.firstName]: "",
		[INPUT_NAMES.lastName]: "",
		[INPUT_NAMES.phoneNumber]: "",
		[INPUT_NAMES.referral]: params.referralcode ? params.referralcode : "",
	})
);
